import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import { Statistics } from '../../types';
import { io, Socket } from 'socket.io-client';

interface HeaderProps {
  onShowAboutModal: () => void;
}

const Header: React.FC<HeaderProps> = ({ onShowAboutModal }) => {
  const [statistics, setStatistics] = useState<Statistics>({ promptsImproved: 0, lastUpdated: '' });
  const [, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    // Cargar estadísticas iniciales
    loadStatistics();

    // Configurar WebSocket para actualizaciones en tiempo real
    // Detectar si estamos en producción basándose en la URL
    const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
    const socketUrl = isProduction ? window.location.origin : 'http://localhost:3001';
      
    const newSocket = io(socketUrl);
    setSocket(newSocket);

    // Escuchar actualizaciones de estadísticas
    newSocket.on('statistics-updated', (updatedStats: Statistics) => {
      setStatistics(updatedStats);
    });

    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, []);

  const loadStatistics = async () => {
    try {
      const stats = await api.getStatistics();
      setStatistics(stats);
    } catch (error) {
      console.error('Error loading statistics:', error);
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <img src="/logo-compacto.png" alt="Logo" className="header-logo" />
          <h1 className="header-title">Metaprompting (Infomed Guru)</h1>
        </div>
        
        <div className="header-center">
          <div className="statistics-counter">
            <span className="statistics-label">Prompts Mejorados:</span>
            <span className="statistics-value">{statistics.promptsImproved.toLocaleString()}</span>
          </div>
        </div>

        <div className="header-right">
          <button 
            type="button"
            onClick={onShowAboutModal}
            className="about-button"
            title="Información sobre Metaprompting"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <path d="M9,9h0a3,3,0,0,1,6,0c0,2-3,3-3,3"/>
              <path d="M12,17h.01"/>
            </svg>
            Acerca de
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;